export default "__VITE_ASSET__83f0a4f1__"